/* ThermoAspen Heater Catalogue v1.2.1
 * Stage 1 — standalone Harvia wood-burning heater data authority.
 * This asset does not alter current Sauna Designer behaviour.
 */
(function(W){
'use strict';
var VERSION='1.2.2',SCHEMA_VERSION=1,UNITS='mm';
/* Model ids renamed in 1.2.2 (identical specification). Saved designs and share links that use an old id still resolve. */
var LEGACY_MODEL_IDS={'harvia-spirit-sp60fc':'harvia-spirit-sp60e','harvia-spirit-sp90fc':'harvia-spirit-sp90e','harvia-legend-po70fc':'harvia-legend-po70e','harvia-legend-po110fc':'harvia-legend-po110e','harvia-linear-22-greenflame':'harvia-linear-22','harvia-legend-240-vision':'harvia-legend-240'};
function normaliseModelId(id){return typeof id==='string'&&Object.prototype.hasOwnProperty.call(LEGACY_MODEL_IDS,id)?LEGACY_MODEL_IDS[id]:id}
function clone(v){return v==null?v:JSON.parse(JSON.stringify(v))}
function isNum(v){return typeof v==='number'&&isFinite(v)}
function pos(v){return isNum(v)&&v>0}
function issue(a,code,path,message){a.push({code:code,path:path,message:message})}

function electricModel(id,itemNumber,name,kw,min,max,width,depth,height,side,front,net,stones,url){
  return{
    id:id,identity:{manufacturer:'Harvia',family:'The Wall',model:name,itemNumber:itemNumber,fuel:'electric'},
    selection:{enabled:true,priority:Math.round(kw*10)},
    sizing:{nominalOutputKw:kw,saunaVolumeMinM3:min,saunaVolumeMaxM3:max,minimumRoomHeightMm:2000,sizingPolicyId:'harvia-electric-v1'},
    physical:{installationLocation:'wall',widthMm:width,depthMm:depth,heightMm:height,minimumMountHeightMm:80,netWeightKg:net,stoneCapacityKg:stones},
    clearances:{base:{combustible:{frontMm:front,rearMm:null,leftMm:side,rightMm:side,aboveMm:1200},reference:'heater-body',
      verification:{rear:'requires-manual-review: installed bracket/fastening detail, not independent rear safety clearance',
        floor:'80 mm specified on product page; bracket must be installed per manual'}}},
    operationalZones:{},flue:{outlets:{}},
    compatibleProtectionConfigurationIds:[],compatibleFloorSystemIds:[],
    controls:{type:'integrated-timer-and-thermostat',sensorRequirements:'per manufacturer instructions',phaseSelection:'deferred'},
    verification:{status:'conditional-manufacturer-mounting-review',criticalDataComplete:false,
      blockingItems:['Rear wall mounting/bracket details must be verified in official model manual','Bench / guard interface and sensor/control installation must be checked']},
    source:{productPage:url}
  };
}

var DATA={
  schemaVersion:1,
  catalogueVersion:'1.2.1',
  manufacturer:'Harvia',
  units:'mm',

  coordinateSystems:{
    stoveLocal:{
      id:'ta-heater-local-v1',
      units:'mm',
      origin:'rear-left-bottom of resolved heater body at finished floor level',
      axes:{x:'left-to-right when viewed from stove front',y:'up',z:'rear-to-front'}
    }
  },

  policies:{
    initialScope:{fuel:'wood',conventionalRoomFiredOnly:true,excludeThroughWallAndWaterTankVariants:true},
    sizingPolicyId:'harvia-wood-v1',
    sizingPolicies:{
      'harvia-wood-v1':{
        nonInsulatedSurfaceAdditionM3PerM2:1.2,
        nonInsulatedSurfaceTypes:['brick','glass','tile','concrete'],
        massiveLogVolumeMultiplier:1.5,
        sourceStatus:'verified-manufacturer-instructions'
      }
    },
    recommendation:{
      preferSmallestSuitableModel:true,
      preferUnshieldedWhenPractical:true,
      addManufacturerProtectionOnlyWhenMateriallyUseful:true,
      preferSimplestApprovedProtectionConfiguration:true
    },
    buildingPriority:{
      heaterAndFlueHavePriority:true,
      buildingGeometryMustAdaptToReservedHeaterFlueZones:true,
      structuralAdjustmentRulesStatus:'to-be-defined'
    },
    visualGeometryPolicy:{
      criticalInstallationGeometrySource:'manufacturer-dimensional-data-only',
      appearanceGeometryMayUseManufacturerProductImagery:true,
      appearanceGeometryIsNeverSafetyAuthority:true,
      rendererMustUsePhysicalEnvelopeForOverallSize:true,
      rendererMustUseFlueOutletGeometryForCollarPosition:true,
      rendererMustNotInferClearanceFromVisibleMesh:true,
      fidelityClasses:{
        exact:'manufacturer-dimensioned',
        proportional:'manufacturer-image-referenced',
        semantic:'recognisable-feature-contract'
      }
    },
    release:{automaticSelectionRequiresVerifiedCriticalData:true},
    plannedConsumers:{
      cuttingManufacturingStoveSection:{
        menuOrder:['Stock','Timber','Sheet Material','Windows/Door','Stove'],
        purpose:'visualise the selected stove, protection and complete flue installation',
        presentationContract:{
          views:['assembly-3d','installation-section','component-list'],
          allowExplodedAssembly:true,
          distinguishSingleWallAndInsulatedFlue:true,
          showPenetrations:true,
          showProtectionSystems:true,
          showClearanceZonesOnDemand:true
        },
        needs:['resolved-stove-geometry','protection-components','floor-protection','flue-segments','fittings','penetrations','installation-metadata','component-graph']
      }
    }
  },

  visualProfiles:{

    'harvia-electric-pillar-visual-v1':{id:'harvia-electric-pillar-visual-v1',fidelity:'semantic-plus-proportional',body:{form:'cylindrical-stone-cage',finish:'manufacturer-black-or-steel',top:'open-stone-bed'},notes:'Visual only; outside envelope comes from model.physical, safety from model.clearances.'},
    'harvia-spirit-visual-v1':{id:'harvia-spirit-visual-v1',fidelity:'semantic-plus-proportional',body:{form:'curved-open-stone-wall-unit',finish:'black-steel'},notes:'Appearance reference only.'},
    'harvia-linear-22-visual-v1':{id:'harvia-linear-22-visual-v1',fidelity:'semantic-plus-proportional',body:{form:'rectangular-cabinet-with-large-glass-door',finish:'black-steel'},notes:'Appearance reference only.'},
    'harvia-m3-visual-v1':{
      id:'harvia-m3-visual-v1',
      fidelity:'semantic-plus-proportional',
      overallEnvelopeAuthority:'model.physical',
      flueCollarAuthority:'model.flue.outlets',
      body:{
        form:'rectangular-steel-cabinet',
        finish:'graphite-black',
        frontTreatment:'stainless-steel-air-flow-spoiler',
        top:'open-stone-bed'
      },
      components:[
        {id:'main-body',role:'cabinet',primitiveHint:'box',dimensionAuthority:'overall-envelope'},
        {id:'stone-bed',role:'stones',primitiveHint:'irregular-stone-volume',dimensionAuthority:'visual-proportion'},
        {id:'front-spoiler',role:'stainless-air-flow-spoiler',primitiveHint:'thin-panel',dimensionAuthority:'visual-proportion'},
        {id:'firebox-door',role:'cast-iron-glass-door',primitiveHint:'framed-glass-panel',dimensionAuthority:'visual-proportion'},
        {id:'door-handle',role:'metal-handle',primitiveHint:'cylinder-and-rod',dimensionAuthority:'visual-proportion'},
        {id:'ash-area',role:'lower-front-ash-access',primitiveHint:'panel',dimensionAuthority:'visual-proportion'},
        {id:'top-flue-collar',role:'flue-collar',primitiveHint:'cylinder',dimensionAuthority:'flue-outlet'},
        {id:'rear-flue-collar',role:'flue-collar',primitiveHint:'cylinder',dimensionAuthority:'flue-outlet'}
      ],
      visualReferences:[
        {type:'manufacturer-product-page',url:'https://www.harvia.com/en/products/WKM3/m3-black'}
      ],
      notes:'Use the exact outer envelope and outlet positions; subcomponent proportions are visual only until dimensioned manufacturer drawings are available.'
    },

    'harvia-linear-16-visual-v1':{
      id:'harvia-linear-16-visual-v1',
      fidelity:'semantic-plus-proportional',
      overallEnvelopeAuthority:'model.physical',
      flueCollarAuthority:'model.flue.outlets',
      body:{
        form:'rectangular-steel-cabinet',
        finish:'matte-black',
        frontTreatment:'flat-sculptural-front',
        top:'open-recessed-stone-bed'
      },
      components:[
        {id:'main-body',role:'cabinet',primitiveHint:'box',dimensionAuthority:'overall-envelope'},
        {id:'stone-bed',role:'stones',primitiveHint:'irregular-stone-volume',dimensionAuthority:'visual-proportion'},
        {id:'firebox-door',role:'reversible-cast-iron-glass-door',primitiveHint:'framed-glass-panel',dimensionAuthority:'visual-proportion'},
        {id:'door-handle',role:'metal-handle',primitiveHint:'cylinder-and-rod',dimensionAuthority:'visual-proportion'},
        {id:'lower-front',role:'ash-and-air-control-zone',primitiveHint:'panel',dimensionAuthority:'visual-proportion'},
        {id:'top-flue-collar',role:'flue-collar',primitiveHint:'cylinder',dimensionAuthority:'flue-outlet'},
        {id:'rear-flue-collar',role:'flue-collar',primitiveHint:'cylinder',dimensionAuthority:'flue-outlet'}
      ],
      visualReferences:[
        {type:'manufacturer-product-page',url:'https://www.harvia.com/en/products/WK160C/linear-16-black'}
      ],
      notes:'Linear 16 must remain visually distinct from M3 despite similar size; the body/front language is simpler and fully black.'
    },

    'harvia-legend-150-visual-v1':{
      id:'harvia-legend-150-visual-v1',
      fidelity:'semantic-plus-proportional',
      overallEnvelopeAuthority:'model.physical',
      flueCollarAuthority:'model.flue.outlets',
      body:{
        form:'cylindrical-stone-cage',
        finish:'black-steel',
        cage:'vertical-bars-with-upper-lower-and-mid-bands',
        top:'open-overfilled-stone-bed'
      },
      components:[
        {id:'stone-cage',role:'black-steel-stone-cage',primitiveHint:'cylindrical-cage',dimensionAuthority:'overall-envelope'},
        {id:'stones',role:'large-stone-mass',primitiveHint:'irregular-stone-volume',dimensionAuthority:'visual-proportion'},
        {id:'firebox-front',role:'front-firebox-projection',primitiveHint:'box',dimensionAuthority:'visual-proportion'},
        {id:'firebox-door',role:'cast-iron-glass-door',primitiveHint:'framed-glass-panel',dimensionAuthority:'visual-proportion'},
        {id:'door-handle',role:'coil-or-metal-handle',primitiveHint:'rod',dimensionAuthority:'visual-proportion'},
        {id:'legs-base',role:'adjustable-base-legs',primitiveHint:'feet',dimensionAuthority:'visual-proportion'},
        {id:'top-flue-collar',role:'flue-collar',primitiveHint:'cylinder',dimensionAuthority:'flue-outlet'},
        {id:'rear-flue-collar',role:'flue-collar',primitiveHint:'cylinder',dimensionAuthority:'flue-outlet'}
      ],
      visualReferences:[
        {type:'manufacturer-product-page',url:'https://www.harvia.com/en/products/WK150LD/legend-150-black'}
      ]
    },

    'harvia-legend-240-visual-v1':{
      id:'harvia-legend-240-visual-v1',
      fidelity:'semantic-plus-proportional',
      overallEnvelopeAuthority:'model.physical',
      flueCollarAuthority:'model.flue.outlets',
      body:{
        form:'cylindrical-stone-cage',
        finish:'fully-matte-black',
        cage:'vertical-bars-with-circumferential-bands',
        top:'open-overfilled-stone-bed',
        distinctiveFeature:'large-vision-glass-hatch'
      },
      components:[
        {id:'stone-cage',role:'black-steel-stone-cage',primitiveHint:'cylindrical-cage',dimensionAuthority:'overall-envelope'},
        {id:'stones',role:'large-stone-mass',primitiveHint:'irregular-stone-volume',dimensionAuthority:'visual-proportion'},
        {id:'firebox-front',role:'front-firebox-projection',primitiveHint:'box',dimensionAuthority:'visual-proportion'},
        {id:'vision-door',role:'large-glass-firebox-door',primitiveHint:'large-framed-glass-panel',dimensionAuthority:'visual-proportion'},
        {id:'door-handle',role:'metal-handle',primitiveHint:'rod',dimensionAuthority:'visual-proportion'},
        {id:'adjustable-feet',role:'adjustable-feet',primitiveHint:'feet',dimensionAuthority:'visual-proportion'},
        {id:'top-flue-collar',role:'flue-collar',primitiveHint:'cylinder',dimensionAuthority:'flue-outlet'},
        {id:'rear-flue-collar',role:'flue-collar',primitiveHint:'cylinder',dimensionAuthority:'flue-outlet'}
      ],
      visualReferences:[
        {type:'manufacturer-product-page',url:'https://www.harvia.com/en/products/WKLE20M10/legend-240-bimschv2-black'}
      ],
      notes:'The current Vision model must not reuse the older Legend 240 door appearance; Harvia describes the current glass hatch as 90% larger than before.'
    },

    'harvia-legend-300-visual-v1':{
      id:'harvia-legend-300-visual-v1',
      fidelity:'semantic-plus-proportional',
      overallEnvelopeAuthority:'model.physical',
      flueCollarAuthority:'model.flue.outlets',
      body:{
        form:'tall-cylindrical-stone-cage',
        finish:'black-steel',
        cage:'vertical-bars-with-circumferential-bands',
        top:'open-overfilled-stone-bed'
      },
      components:[
        {id:'stone-cage',role:'black-steel-stone-cage',primitiveHint:'tall-cylindrical-cage',dimensionAuthority:'overall-envelope'},
        {id:'stones',role:'very-large-stone-mass',primitiveHint:'irregular-stone-volume',dimensionAuthority:'visual-proportion'},
        {id:'firebox-front',role:'front-firebox-projection',primitiveHint:'box',dimensionAuthority:'visual-proportion'},
        {id:'firebox-door',role:'large-steel-framed-glass-door',primitiveHint:'framed-glass-panel',dimensionAuthority:'visual-proportion'},
        {id:'door-handle',role:'metal-handle',primitiveHint:'rod',dimensionAuthority:'visual-proportion'},
        {id:'adjustable-feet',role:'adjustable-feet',primitiveHint:'feet',dimensionAuthority:'visual-proportion'},
        {id:'top-flue-collar',role:'flue-collar',primitiveHint:'cylinder',dimensionAuthority:'flue-outlet'},
        {id:'rear-flue-collar',role:'flue-collar',primitiveHint:'cylinder',dimensionAuthority:'flue-outlet'}
      ],
      visualReferences:[
        {type:'manufacturer-product-page',url:'https://www.harvia.com/en/products/WK300LD/legend-300-black'}
      ]
    }
  },

  models:{

  // Electric heaters: EU Harvia The Wall Black Steel range. Rear mounting clearance is
  // NOT published as a free-standing distance; mounting-bracket detail requires manual verification.
  // The value 0 below is a DRAWING PLACEHOLDER only and not a certified rear clearance.
  'harvia-the-wall-sw45': electricModel('harvia-the-wall-sw45','HSW450400M','SW45',4.5,3,6,430,260,610,35,20,11.7,20,'https://www.harvia.com/en/products/HSW450400M/the-wall-sw45-45-kw-blacksteel'),
  'harvia-the-wall-sw60': electricModel('harvia-the-wall-sw60','HSW600400M','SW60',6,5,8,430,260,610,40,40,11.7,20,'https://www.harvia.com/en/products/HSW600400M/the-wall-sw60-60-kw-blacksteel'),
  'harvia-the-wall-sw80': electricModel('harvia-the-wall-sw80','HSW800400M','SW80',8,7,12,430,260,700,70,30,13.6,20,'https://www.harvia.com/en/products/HSW800400M/the-wall-sw80-80-kw-blacksteel'),
  'harvia-the-wall-sw90': electricModel('harvia-the-wall-sw90','HSW900400M','SW90',9,8,14,430,260,700,80,30,13.6,20,'https://www.harvia.com/en/products/HSW900400M/the-wall-sw90-90-kw-blacksteel'),


  'harvia-cilindro-pc70':{
    id:'harvia-cilindro-pc70',visualProfileId:'harvia-electric-pillar-visual-v1',identity:{manufacturer:'Harvia',family:'Cilindro',model:'Cilindro PC70',itemNumber:'HPC700400M',fuel:'electric'},
    selection:{enabled:true,priority:68},
    sizing:{nominalOutputKw:6.8,saunaVolumeMinM3:6,saunaVolumeMaxM3:10,minimumRoomHeightMm:2000,sizingPolicyId:'harvia-electric-v1'},
    physical:{installationLocation:'floor',widthMm:320,depthMm:320,heightMm:930,minimumMountHeightMm:0,netWeightKg:10,stoneCapacityKg:80},
    clearances:{base:{combustible:{frontMm:100,rearMm:100,leftMm:100,rightMm:100,aboveMm:950},reference:'heater-body'}},
    flue:{outlets:{}},operationalZones:{},compatibleProtectionSystemIds:['harvia-hpc11m'],compatibleProtectionConfigurationIds:[],compatibleFloorSystemIds:[],
    controls:{type:'manual',phaseSelection:'deferred',requiredAccessories:'manufacturer supplied control, sensor and/or door-switch details to be verified'},
    verification:{status:'manufacturer-published-body-clearances; accessory-reductions-not-automated',criticalDataComplete:false,blockingItems:['Electric control/sensor positioning and any optional shield installation to be confirmed against model manual']},
    source:{productPage:'https://www.harvia.com/en/products/HPC700400M/cilindro-pc70-68-kw-blacksteel',catalogue:'Harvia European equipment catalogue 2026'}
  },

  'harvia-cilindro-pc90':{
    id:'harvia-cilindro-pc90',visualProfileId:'harvia-electric-pillar-visual-v1',identity:{manufacturer:'Harvia',family:'Cilindro',model:'Cilindro PC90',itemNumber:'HPC900400M',fuel:'electric'},
    selection:{enabled:true,priority:90},
    sizing:{nominalOutputKw:9,saunaVolumeMinM3:8,saunaVolumeMaxM3:14,minimumRoomHeightMm:2000,sizingPolicyId:'harvia-electric-v1'},
    physical:{installationLocation:'floor',widthMm:320,depthMm:320,heightMm:930,minimumMountHeightMm:0,netWeightKg:10,stoneCapacityKg:80},
    clearances:{base:{combustible:{frontMm:100,rearMm:100,leftMm:100,rightMm:100,aboveMm:950},reference:'heater-body'}},
    flue:{outlets:{}},operationalZones:{},compatibleProtectionSystemIds:['harvia-hpc11m'],compatibleProtectionConfigurationIds:[],compatibleFloorSystemIds:[],
    controls:{type:'manual',phaseSelection:'deferred',requiredAccessories:'manufacturer supplied control, sensor and/or door-switch details to be verified'},
    verification:{status:'manufacturer-published-body-clearances; accessory-reductions-not-automated',criticalDataComplete:false,blockingItems:['Electric control/sensor positioning and any optional shield installation to be confirmed against model manual']},
    source:{productPage:'https://www.harvia.com/en/products/HPC900400M/cilindro-pc90-90-kw-blacksteel',catalogue:'Harvia European equipment catalogue 2026'}
  },

  'harvia-spirit-sp60e':{
    id:'harvia-spirit-sp60e',visualProfileId:'harvia-spirit-visual-v1',identity:{manufacturer:'Harvia',family:'Spirit',model:'Spirit SP60E',itemNumber:'HSPE604M',fuel:'electric'},
    selection:{enabled:true,priority:60},
    sizing:{nominalOutputKw:6,saunaVolumeMinM3:5,saunaVolumeMaxM3:8,minimumRoomHeightMm:2000,sizingPolicyId:'harvia-electric-v1'},
    physical:{installationLocation:'wall',widthMm:385,depthMm:335,heightMm:750,minimumMountHeightMm:100,netWeightKg:14.4,stoneCapacityKg:60},
    clearances:{base:{combustible:{frontMm:60,rearMm:null,leftMm:60,rightMm:60,aboveMm:900},reference:'heater-body'}},
    flue:{outlets:{}},operationalZones:{},compatibleProtectionSystemIds:[],compatibleProtectionConfigurationIds:[],compatibleFloorSystemIds:[],
    controls:{type:'Fenix WiFi kit included',phaseSelection:'deferred',requiredAccessories:'manufacturer supplied control, sensor and/or door-switch details to be verified'},
    verification:{status:'manufacturer-published-body-clearances; accessory-reductions-not-automated',criticalDataComplete:false,blockingItems:['Electric control/sensor positioning and any optional shield installation to be confirmed against model manual']},
    source:{productPage:'https://www.harvia.com/en-US/products/HSPE604M/spirit-sp60e-60-kw-black',catalogue:'Harvia European equipment catalogue 2026'}
  },

  'harvia-spirit-sp90e':{
    id:'harvia-spirit-sp90e',visualProfileId:'harvia-spirit-visual-v1',identity:{manufacturer:'Harvia',family:'Spirit',model:'Spirit SP90E',itemNumber:'HSPE904M',fuel:'electric'},
    selection:{enabled:true,priority:90},
    sizing:{nominalOutputKw:9,saunaVolumeMinM3:8,saunaVolumeMaxM3:14,minimumRoomHeightMm:2000,sizingPolicyId:'harvia-electric-v1'},
    physical:{installationLocation:'wall',widthMm:385,depthMm:335,heightMm:750,minimumMountHeightMm:100,netWeightKg:14.9,stoneCapacityKg:60},
    clearances:{base:{combustible:{frontMm:80,rearMm:null,leftMm:80,rightMm:80,aboveMm:900},reference:'heater-body'}},
    flue:{outlets:{}},operationalZones:{},compatibleProtectionSystemIds:[],compatibleProtectionConfigurationIds:[],compatibleFloorSystemIds:[],
    controls:{type:'Fenix WiFi kit included',phaseSelection:'deferred',requiredAccessories:'manufacturer supplied control, sensor and/or door-switch details to be verified'},
    verification:{status:'manufacturer-published-body-clearances; accessory-reductions-not-automated',criticalDataComplete:false,blockingItems:['Electric control/sensor positioning and any optional shield installation to be confirmed against model manual']},
    source:{productPage:'https://www.harvia.com/en/products/HSPE904M/spirit-sp90e-90-kw-black',catalogue:'Harvia European equipment catalogue 2026'}
  },

  'harvia-legend-po70e':{
    id:'harvia-legend-po70e',visualProfileId:'harvia-electric-pillar-visual-v1',identity:{manufacturer:'Harvia',family:'Legend',model:'Legend PO70E',itemNumber:'HPOE704',fuel:'electric'},
    selection:{enabled:true,priority:68},
    sizing:{nominalOutputKw:6.8,saunaVolumeMinM3:6,saunaVolumeMaxM3:10,minimumRoomHeightMm:2000,sizingPolicyId:'harvia-electric-v1'},
    physical:{installationLocation:'floor',widthMm:325,depthMm:325,heightMm:1060,minimumMountHeightMm:0,netWeightKg:18,stoneCapacityKg:100},
    clearances:{base:{combustible:{frontMm:100,rearMm:100,leftMm:100,rightMm:100,aboveMm:840},reference:'heater-body'}},
    flue:{outlets:{}},operationalZones:{},compatibleProtectionSystemIds:['harvia-hpo11'],compatibleProtectionConfigurationIds:[],compatibleFloorSystemIds:[],
    controls:{type:'Fenix WiFi + sensors included',phaseSelection:'deferred',requiredAccessories:'manufacturer supplied control, sensor and/or door-switch details to be verified'},
    verification:{status:'manufacturer-published-body-clearances; accessory-reductions-not-automated',criticalDataComplete:false,blockingItems:['Electric control/sensor positioning and any optional shield installation to be confirmed against model manual']},
    source:{productPage:'https://www.harvia.com/en-US/products/HPOE704/legend-po70e-68-kw-black',catalogue:'Harvia European equipment catalogue 2026'}
  },

  'harvia-legend-po110e':{
    id:'harvia-legend-po110e',visualProfileId:'harvia-electric-pillar-visual-v1',identity:{manufacturer:'Harvia',family:'Legend',model:'Legend PO110E',itemNumber:'HPOE1104',fuel:'electric'},
    selection:{enabled:true,priority:108},
    sizing:{nominalOutputKw:10.8,saunaVolumeMinM3:9,saunaVolumeMaxM3:18,minimumRoomHeightMm:2000,sizingPolicyId:'harvia-electric-v1'},
    physical:{installationLocation:'floor',widthMm:325,depthMm:325,heightMm:1060,minimumMountHeightMm:0,netWeightKg:18.5,stoneCapacityKg:100},
    clearances:{base:{combustible:{frontMm:100,rearMm:100,leftMm:100,rightMm:100,aboveMm:840},reference:'heater-body'}},
    flue:{outlets:{}},operationalZones:{},compatibleProtectionSystemIds:['harvia-hpo11'],compatibleProtectionConfigurationIds:[],compatibleFloorSystemIds:[],
    controls:{type:'Fenix WiFi + sensors included',phaseSelection:'deferred',requiredAccessories:'manufacturer supplied control, sensor and/or door-switch details to be verified'},
    verification:{status:'manufacturer-published-body-clearances; accessory-reductions-not-automated',criticalDataComplete:false,blockingItems:['Electric control/sensor positioning and any optional shield installation to be confirmed against model manual']},
    source:{productPage:'https://www.harvia.com/en-US/products/HPOE1104/legend-po110e-108-kw-black',catalogue:'Harvia European equipment catalogue 2026'}
  },

  'harvia-linear-22':{
    id:'harvia-linear-22',visualProfileId:'harvia-linear-22-visual-v1',identity:{manufacturer:'Harvia',family:'Linear',model:'Linear 22',itemNumber:'WKLI20M10',fuel:'wood'},
    selection:{enabled:true,priority:25},
    sizing:{nominalOutputKw:15.7,saunaVolumeMinM3:9,saunaVolumeMaxM3:18,minimumRoomHeightMm:2035,sizingPolicyId:'harvia-wood-v1'},
    physical:{installationLocation:'floor',widthMm:450,depthMm:510,heightMm:770,netWeightKg:66,stoneCapacityKg:40,stoneSizeMinMm:100,stoneSizeMaxMm:150},
    clearances:{base:{combustible:{frontMm:500,rearMm:380,leftMm:400,rightMm:400,aboveMm:1265},reference:'heater-body'}},
    operationalZones:{fireboxAccess:{status:'manufacturer-front-clearance-available',frontDepthMm:null,sideAllowanceMm:null}},
    flue:{nominalDiameterMm:115,diameterVerificationStatus:'verified',outlets:{top:{enabled:true,verificationStatus:'verified',centreMm:{x:225.0,y:708,z:136},axis:{x:0,y:1,z:0}},rear:{enabled:true,verificationStatus:'verified',centreMm:{x:225.0,y:558,z:0},axis:{x:0,y:0,z:-1}}}},
    compatibleProtectionSystemIds:['harvia-wl525'],compatibleProtectionConfigurationIds:['harvia-linear-22-unshielded','harvia-linear-22-wl525-left','harvia-linear-22-wl525-right','harvia-linear-22-wl575-full'],compatibleFloorSystemIds:['harvia-wl100'],
    protectionConfigurationMode:'explicit-linear-22',panelProtectionSystemId:'harvia-wl525',
    verification:{status:'verified-core',criticalDataComplete:true,visualGeometryComplete:false,blockingItems:['Detailed 3D appearance and installed shield geometry remain conditional','Floor substrate/structure must be separately confirmed']},
    source:{productPage:'https://www.harvia.com/en/products/WKLI20M10/linear-22-bimschv2-black',clearanceSource:'Harvia 2026 wood-heater catalogue technical data',flueSource:'Harvia manufacturer X/Y/Z connection dimensions'}
  },

  'harvia-cilindro-16-wood':{
    id:'harvia-cilindro-16-wood',visualProfileId:'harvia-electric-pillar-visual-v1',identity:{manufacturer:'Harvia',family:'Cilindro wood',model:'Cilindro 16',itemNumber:'WKPC16S',fuel:'wood'},
    selection:{enabled:true,priority:35},
    sizing:{nominalOutputKw:16,saunaVolumeMinM3:6,saunaVolumeMaxM3:13,minimumRoomHeightMm:2000,sizingPolicyId:'harvia-wood-v1'},
    physical:{installationLocation:'floor',widthMm:557,depthMm:557,heightMm:750,netWeightKg:54,stoneCapacityKg:120,stoneSizeMinMm:100,stoneSizeMaxMm:150},
    clearances:{base:{combustible:{frontMm:500,rearMm:200,leftMm:150,rightMm:150,aboveMm:1000},reference:'heater-body'}},
    operationalZones:{fireboxAccess:{status:'manufacturer-front-clearance-available',frontDepthMm:null,sideAllowanceMm:null}},
    flue:{nominalDiameterMm:115,diameterVerificationStatus:'verified',outlets:{top:{enabled:true,verificationStatus:'verified',centreMm:{x:278.5,y:630,z:175},axis:{x:0,y:1,z:0}},rear:{enabled:true,verificationStatus:'verified',centreMm:{x:278.5,y:550,z:0},axis:{x:0,y:0,z:-1}}}},
    compatibleProtectionSystemIds:['harvia-wl200pc'],compatibleProtectionConfigurationIds:[],compatibleFloorSystemIds:['harvia-wl100'],
    protectionConfigurationMode:'wall-only-panel-array',panelProtectionSystemId:'harvia-wl200pc',
    verification:{status:'verified-core',criticalDataComplete:true,visualGeometryComplete:false,blockingItems:['Detailed 3D appearance and installed shield geometry remain conditional','Floor substrate/structure must be separately confirmed']},
    source:{productPage:'https://www.harvia.com/en/products/WKPC16S/cilindro-16',clearanceSource:'Harvia 2026 wood-heater catalogue technical data',flueSource:'Harvia manufacturer X/Y/Z connection dimensions'}
  },

  'harvia-cilindro-20-wood':{
    id:'harvia-cilindro-20-wood',visualProfileId:'harvia-electric-pillar-visual-v1',identity:{manufacturer:'Harvia',family:'Cilindro wood',model:'Cilindro 20',itemNumber:'WKPC20S',fuel:'wood'},
    selection:{enabled:true,priority:36},
    sizing:{nominalOutputKw:17,saunaVolumeMinM3:8,saunaVolumeMaxM3:20,minimumRoomHeightMm:2000,sizingPolicyId:'harvia-wood-v1'},
    physical:{installationLocation:'floor',widthMm:557,depthMm:557,heightMm:773,netWeightKg:62,stoneCapacityKg:120,stoneSizeMinMm:100,stoneSizeMaxMm:150},
    clearances:{base:{combustible:{frontMm:500,rearMm:200,leftMm:150,rightMm:150,aboveMm:1000},reference:'heater-body'}},
    operationalZones:{fireboxAccess:{status:'manufacturer-front-clearance-available',frontDepthMm:null,sideAllowanceMm:null}},
    flue:{nominalDiameterMm:115,diameterVerificationStatus:'verified',outlets:{top:{enabled:true,verificationStatus:'verified',centreMm:{x:278.5,y:670,z:150},axis:{x:0,y:1,z:0}},rear:{enabled:true,verificationStatus:'verified',centreMm:{x:278.5,y:550,z:0},axis:{x:0,y:0,z:-1}}}},
    compatibleProtectionSystemIds:['harvia-wl200pc'],compatibleProtectionConfigurationIds:[],compatibleFloorSystemIds:['harvia-wl100'],
    protectionConfigurationMode:'wall-only-panel-array',panelProtectionSystemId:'harvia-wl200pc',
    verification:{status:'verified-core',criticalDataComplete:true,visualGeometryComplete:false,blockingItems:['Detailed 3D appearance and installed shield geometry remain conditional','Floor substrate/structure must be separately confirmed']},
    source:{productPage:'https://www.harvia.com/en/products/WKPC20S/cilindro-20-steel',clearanceSource:'Harvia 2026 wood-heater catalogue technical data',flueSource:'Harvia manufacturer X/Y/Z connection dimensions'}
  },
    'harvia-m3':{
      id:'harvia-m3',
      visualProfileId:'harvia-m3-visual-v1',
      identity:{manufacturer:'Harvia',family:'M series',model:'M3',itemNumber:'WKM3',typeCode:'M16',fuel:'wood'},
      selection:{enabled:true,priority:10},
      sizing:{nominalOutputKw:16.5,saunaVolumeMinM3:6,saunaVolumeMaxM3:13,minimumRoomHeightMm:2000,sizingPolicyId:'harvia-wood-v1'},
      physical:{installationLocation:'floor',widthMm:390,depthMm:430,heightMm:710,netWeightKg:45,stoneCapacityKg:30,stoneSizeMinMm:100,stoneSizeMaxMm:150},
      clearances:{base:{
        combustible:{frontMm:300,rearMm:300,leftMm:250,rightMm:250,aboveMm:1200},
        nonCombustible:{frontMm:300,rearMm:100,leftMm:100,rightMm:100,aboveMm:null},
        reference:'heater-body'
      }},
      operationalZones:{
        fireboxAccess:{
          status:'reserved-for-engine-stage',
          frontDepthMm:null,
          sideAllowanceMm:null,
          note:'Operational loading/ash-removal space remains separate from fire-safety clearance.'
        }
      },
      flue:{
        nominalDiameterMm:115,
        diameterVerificationStatus:'verified',
        manufacturerOutletLocationMm:{X:560,Y:640,Z:120},
        manufacturerCoordinateMeaning:{
          X:'rear outlet centre above finished floor',
          Y:'upper outlet centre above finished floor',
          Z:'upper outlet centre from stove rear edge'
        },
        outlets:{
          top:{
            enabled:true,
            verificationStatus:'verified',
            centreMm:{x:195,y:640,z:120},
            toleranceMm:{x:0,y:0,z:0},
            axis:{x:0,y:1,z:0}
          },
          rear:{
            enabled:true,
            verificationStatus:'verified',
            centreMm:{x:195,y:560,z:0},
            toleranceMm:{x:0,y:0,z:0},
            axis:{x:0,y:0,z:-1}
          }
        }
      },
      compatibleProtectionSystemIds:['harvia-wl400','harvia-wl450'],
      compatibleProtectionConfigurationIds:['harvia-m3-unshielded','harvia-m3-wl400-left','harvia-m3-wl400-right','harvia-m3-wl450-full'],
      compatibleFloorSystemIds:['harvia-wl100'],
      verification:{
        status:'verified-core',
        criticalDataComplete:true,
        visualGeometryComplete:false,
        blockingItems:[
          'Detailed parametric render dimensions remain to be added before accurate recognisable 3D representation.',
          'Operational firebox loading/ash-removal zone remains to be defined in Heater System Engine.'
        ]
      },
      source:{
        productPage:'https://www.harvia.com/en/products/WKM3/wkm3',
        installationManual:'Harvia M1/M2/M3/Linear family installation instructions',
        technicalOutletTable:'Harvia wood-burning heater technical data: X=560, Y=640, Z=120'
      }
    },

    'harvia-linear-16':{
      id:'harvia-linear-16',
      visualProfileId:'harvia-linear-16-visual-v1',
      identity:{manufacturer:'Harvia',family:'Linear',model:'Linear 16',itemNumber:'WK160C',typeCode:'LI16',fuel:'wood'},
      selection:{enabled:true,priority:20},
      sizing:{nominalOutputKw:17.9,saunaVolumeMinM3:6,saunaVolumeMaxM3:16,minimumRoomHeightMm:2000,sizingPolicyId:'harvia-wood-v1'},
      physical:{installationLocation:'floor',widthMm:420,depthMm:450,heightMm:735,netWeightKg:46.6,stoneCapacityKg:36,stoneSizeMinMm:100,stoneSizeMaxMm:150},
      clearances:{base:{
        combustible:{frontMm:400,rearMm:350,leftMm:300,rightMm:300,aboveMm:1300},
        nonCombustible:{frontMm:null,rearMm:50,leftMm:50,rightMm:50,aboveMm:null},
        reference:'heater-body'
      }},
      operationalZones:{
        fireboxAccess:{
          status:'reserved-for-engine-stage',
          frontDepthMm:null,
          sideAllowanceMm:null,
          note:'Door opening direction is reversible. Operational loading/ash-removal space remains separate from fire-safety clearance.'
        }
      },
      flue:{
        nominalDiameterMm:115,
        diameterVerificationStatus:'verified',
        manufacturerOutletLocationMm:{X:560,Y:635,Z:130},
        manufacturerCoordinateMeaning:{
          X:'rear outlet centre above finished floor',
          Y:'upper outlet centre above finished floor',
          Z:'upper outlet centre from stove rear edge'
        },
        outlets:{
          top:{
            enabled:true,
            verificationStatus:'verified',
            centreMm:{x:210,y:635,z:130},
            toleranceMm:{x:0,y:0,z:0},
            axis:{x:0,y:1,z:0}
          },
          rear:{
            enabled:true,
            verificationStatus:'verified',
            centreMm:{x:210,y:560,z:0},
            toleranceMm:{x:0,y:0,z:0},
            axis:{x:0,y:0,z:-1}
          }
        }
      },
      compatibleProtectionSystemIds:['harvia-wl425','harvia-wl475'],
      compatibleProtectionConfigurationIds:['harvia-linear-16-unshielded','harvia-linear-16-wl425-left','harvia-linear-16-wl425-right','harvia-linear-16-wl475-full'],
      compatibleFloorSystemIds:['harvia-wl100'],
      verification:{
        status:'verified-core',
        criticalDataComplete:true,
        visualGeometryComplete:false,
        blockingItems:[
          'Detailed parametric render dimensions remain to be added before accurate recognisable 3D representation.',
          'Operational firebox loading/ash-removal zone remains to be defined in Heater System Engine.'
        ]
      },
      source:{
        productPage:'https://www.harvia.com/en/products/WK160C/linear-16-black',
        installationManual:'Harvia M1/M2/M3/Linear family installation instructions',
        technicalOutletTable:'Harvia technical data: X=560, Y=635, Z=130'
      }
    },

    'harvia-legend-150':{
      id:'harvia-legend-150',
      visualProfileId:'harvia-legend-150-visual-v1',
      identity:{manufacturer:'Harvia',family:'Legend',model:'Legend 150',itemNumber:'WK150LD',typeCode:'LE150',fuel:'wood'},
      selection:{enabled:true,priority:30},
      sizing:{nominalOutputKw:16,saunaVolumeMinM3:6,saunaVolumeMaxM3:13,minimumRoomHeightMm:2000,sizingPolicyId:'harvia-wood-v1'},
      physical:{installationLocation:'floor',widthMm:530,depthMm:530,heightMm:740,netWeightKg:61.5,stoneCapacityKg:120,stoneSizeMinMm:100,stoneSizeMaxMm:150,adjustableLegRangeMm:{min:0,max:30}},
      clearances:{base:{
        combustible:{frontMm:500,rearMm:250,leftMm:200,rightMm:200,aboveMm:1000},
        nonCombustible:{frontMm:500,rearMm:100,leftMm:100,rightMm:100,aboveMm:null},
        reference:'heater-body'
      }},
      operationalZones:{fireboxAccess:{status:'reserved-for-engine-stage',frontDepthMm:null,sideAllowanceMm:null}},
      flue:{
        nominalDiameterMm:115,
        diameterVerificationStatus:'verified',
        manufacturerOutletLocationMm:{X:560,Y:640,Z:180},
        manufacturerOutletToleranceMm:{Z:5},
        manufacturerCoordinateMeaning:{
          X:'rear outlet centre above finished floor',
          Y:'upper outlet centre above finished floor',
          Z:'upper outlet centre from stove rear edge'
        },
        outlets:{
          top:{enabled:true,verificationStatus:'verified',centreMm:{x:265,y:640,z:180},toleranceMm:{x:0,y:0,z:5},axis:{x:0,y:1,z:0}},
          rear:{enabled:true,verificationStatus:'verified',centreMm:{x:265,y:560,z:0},toleranceMm:{x:0,y:0,z:0},axis:{x:0,y:0,z:-1}}
        }
      },
      compatibleProtectionSystemIds:['harvia-wl200'],
      compatibleFloorSystemIds:['harvia-wl100'],
      protectionConfigurationMode:'legend-wl200-panel-array',
      verification:{
        status:'verified-core',
        criticalDataComplete:true,
        visualGeometryComplete:false,
        blockingItems:['Exact WL200 installed panel transforms and detailed Legend parametric render geometry remain to be modelled.']
      },
      source:{
        productPage:'https://www.harvia.com/en/products/WK150LD/legend-150-black',
        technicalOutletTable:'Harvia technical data: X=560, Y=640, Z=180 ±5'
      }
    },

    'harvia-legend-240':{
      id:'harvia-legend-240',
      visualProfileId:'harvia-legend-240-visual-v1',
      identity:{manufacturer:'Harvia',family:'Legend',model:'Legend 240',itemNumber:'WKLE20M10',typeCode:'LE240G',fuel:'wood'},
      selection:{enabled:true,priority:40},
      sizing:{nominalOutputKw:15.9,saunaVolumeMinM3:10,saunaVolumeMaxM3:20,minimumRoomHeightMm:2000,sizingPolicyId:'harvia-wood-v1'},
      physical:{installationLocation:'floor',widthMm:600,depthMm:600,heightMm:835,netWeightKg:76.1,stoneCapacityKg:200,stoneSizeMinMm:100,stoneSizeMaxMm:150,adjustableLegRangeMm:{min:0,max:30}},
      clearances:{base:{
        combustible:{frontMm:630,rearMm:250,leftMm:200,rightMm:200,aboveMm:1200},
        nonCombustible:{frontMm:630,rearMm:100,leftMm:100,rightMm:100,aboveMm:null},
        reference:'heater-body'
      }},
      operationalZones:{fireboxAccess:{status:'reserved-for-engine-stage',frontDepthMm:null,sideAllowanceMm:null}},
      flue:{
        nominalDiameterMm:115,
        diameterVerificationStatus:'verified',
        manufacturerOutletLocationMm:{X:560,Y:670,Z:200},
        manufacturerOutletToleranceMm:{Z:5},
        manufacturerCoordinateMeaning:{
          X:'rear outlet centre above finished floor',
          Y:'upper outlet centre above finished floor',
          Z:'upper outlet centre from stove rear edge'
        },
        outlets:{
          top:{enabled:true,verificationStatus:'verified',centreMm:{x:300,y:670,z:200},toleranceMm:{x:0,y:0,z:5},axis:{x:0,y:1,z:0}},
          rear:{enabled:true,verificationStatus:'verified',centreMm:{x:300,y:560,z:0},toleranceMm:{x:0,y:0,z:0},axis:{x:0,y:0,z:-1}}
        }
      },
      compatibleProtectionSystemIds:['harvia-wl200'],
      compatibleFloorSystemIds:['harvia-wl100'],
      protectionConfigurationMode:'legend-wl200-panel-array',
      verification:{
        status:'verified-core',
        criticalDataComplete:true,
        visualGeometryComplete:false,
        blockingItems:[
          'Exact WL200 installed panel transforms and detailed Legend parametric render geometry remain to be modelled.',
          'Harvia current product page gives overall height 835 mm/net weight 76.1 kg; technical tables for closely related/current GreenFlame data may show small revision differences. Product-page geometry is authoritative here.'
        ]
      },
      source:{
        productPage:'https://www.harvia.com/en/products/WKLE20M10/legend-240-bimschv2-black',
        technicalOutletTable:'Harvia current technical data: X=560, Y=670, Z=200 ±5'
      }
    },

    'harvia-legend-300':{
      id:'harvia-legend-300',
      visualProfileId:'harvia-legend-300-visual-v1',
      identity:{manufacturer:'Harvia',family:'Legend',model:'Legend 300',itemNumber:'WK300LD',typeCode:'LE300',fuel:'wood'},
      selection:{enabled:true,priority:50},
      sizing:{nominalOutputKw:23,saunaVolumeMinM3:14,saunaVolumeMaxM3:28,minimumRoomHeightMm:2000,sizingPolicyId:'harvia-wood-v1'},
      physical:{installationLocation:'floor',widthMm:600,depthMm:660,heightMm:1040,netWeightKg:91.4,stoneCapacityKg:260,stoneSizeMinMm:100,stoneSizeMaxMm:150,adjustableLegRangeMm:{min:0,max:30}},
      clearances:{base:{
        combustible:{frontMm:680,rearMm:250,leftMm:200,rightMm:200,aboveMm:1000},
        nonCombustible:{frontMm:680,rearMm:100,leftMm:100,rightMm:100,aboveMm:null},
        reference:'heater-body'
      }},
      operationalZones:{fireboxAccess:{status:'reserved-for-engine-stage',frontDepthMm:null,sideAllowanceMm:null}},
      flue:{
        nominalDiameterMm:115,
        diameterVerificationStatus:'verified',
        manufacturerOutletLocationMm:{X:690,Y:750,Z:210},
        manufacturerOutletToleranceMm:{Z:5},
        manufacturerCoordinateMeaning:{
          X:'rear outlet centre above finished floor',
          Y:'upper outlet centre above finished floor',
          Z:'upper outlet centre from stove rear edge'
        },
        outlets:{
          top:{enabled:true,verificationStatus:'verified',centreMm:{x:300,y:750,z:210},toleranceMm:{x:0,y:0,z:5},axis:{x:0,y:1,z:0}},
          rear:{enabled:true,verificationStatus:'verified',centreMm:{x:300,y:690,z:0},toleranceMm:{x:0,y:0,z:0},axis:{x:0,y:0,z:-1}}
        }
      },
      compatibleProtectionSystemIds:['harvia-wl200'],
      compatibleFloorSystemIds:['harvia-wl100'],
      protectionConfigurationMode:'legend-wl200-panel-array',
      verification:{
        status:'verified-core',
        criticalDataComplete:true,
        visualGeometryComplete:false,
        blockingItems:['Exact WL200 installed panel transforms and detailed Legend parametric render geometry remain to be modelled.']
      },
      source:{
        productPage:'https://www.harvia.com/en/products/WK300LD/legend-300-black',
        technicalOutletTable:'Harvia technical data: X=690, Y=750, Z=210 ±5'
      }
    }
  },

  protectionSystems:{
    'harvia-hpc11m':{id:'harvia-hpc11m',identity:{manufacturer:'Harvia',model:'HPC11M',type:'electric-Cilindro-protective-panel'},compatibleModelIds:['harvia-cilindro-pc70','harvia-cilindro-pc90'],permittedPositions:['left','rear','right'],physical:{heightMm:705,widthMm:350,depthMm:140,netWeightKg:3.8},verification:{status:'compatible-accessory; clearance-datum-not-verified',installedTransformComplete:false},clearanceEffect:{protectedFaceEffectiveClearanceFromHeaterBodyMm:null,frontClearanceUnchanged:true,note:'30 mm stated at protective sheath; heater-body installed-distance datum not verified for automatic adjustment.'},source:{productPage:'https://www.harvia.com/en/products/HPC11M/cilindro-protective-sheath-pc7090-blacksteel'}},
    'harvia-hpo11':{id:'harvia-hpo11',identity:{manufacturer:'Harvia',model:'HPO11',type:'electric-Legend-FC-protective-panel'},compatibleModelIds:['harvia-legend-po70e','harvia-legend-po110e'],permittedPositions:['left','rear','right'],physical:{heightMm:705,widthMm:350,depthMm:140,netWeightKg:3.8},verification:{status:'compatible-accessory; clearance-datum-not-verified',installedTransformComplete:false},clearanceEffect:{protectedFaceEffectiveClearanceFromHeaterBodyMm:null,frontClearanceUnchanged:true,note:'Manual shows 30 mm at HPO11 sheath; heater-body installed-distance datum not fully established.'},source:{productPage:'https://www.harvia.com/en/products/HPO11/legend-protective-sheath-po70po110-black'}},
    'harvia-wl200pc':{id:'harvia-wl200pc',identity:{manufacturer:'Harvia',model:'WL200PC',type:'wood-Cilindro-protective-panel'},compatibleModelIds:['harvia-cilindro-16-wood','harvia-cilindro-20-wood'],permittedPositions:['left','rear','right'],physical:{heightMm:770,widthMm:550,depthMm:179,netWeightKg:4.5},verification:{status:'published-protected-distances; installed-transform-incomplete',installedTransformComplete:false},clearanceEffect:{protectedFaceEffectiveClearanceFromHeaterBodyMm:50,frontClearanceUnchanged:true,note:'Harvia wood catalogue 2026 B/C=50 mm for WL200PC.'},source:{productPage:'https://www.harvia.com/en/products/WL200PC/cilindro-protective-sheath'}},
    'harvia-wl525':{id:'harvia-wl525',identity:{manufacturer:'Harvia',model:'WL525',type:'Linear-22-side-protective-sheath'},compatibleModelIds:['harvia-linear-22'],permittedPositions:['left','right'],physical:{heightMm:855,widthMm:590,depthMm:95,netWeightKg:3.6},verification:{status:'published-protected-distances; installed-transform-incomplete',installedTransformComplete:false},clearanceEffect:{protectedFaceEffectiveClearanceFromHeaterBodyMm:110,frontClearanceUnchanged:true},source:{productPage:'https://www.harvia.com/en/products/WL525/protective-sheath-h22-black'}},
    'harvia-wl575':{id:'harvia-wl575',identity:{manufacturer:'Harvia',model:'WL575',type:'Linear-22-full-protective-sheath'},compatibleModelIds:['harvia-linear-22'],permittedPositions:['full'],physical:{heightMm:855,widthMm:530,depthMm:590,netWeightKg:8.6},verification:{status:'published-protected-distances; installed-transform-incomplete',installedTransformComplete:false},clearanceEffect:{protectedFaceEffectiveClearanceFromHeaterBodyMm:110,frontClearanceUnchanged:true},source:{productPage:'https://www.harvia.com/en/products/WL575/protective-sheath-h22-full-black'}},

    'harvia-wl400':{
      render:{
        role:'stove-side-protective-sheath',
        form:'thin-folded-steel-panel',
        finish:'black-painted-steel',
        overallEnvelopeAuthority:'physical',
        installedTransformAuthority:'heater-system-engine',
        installationVisualRequired:true
      },
      id:'harvia-wl400',
      identity:{manufacturer:'Harvia',model:'WL400',type:'stove-attached-side-sheath'},
      compatibleModelIds:['harvia-m3'],
      permittedPositions:['left','right'],
      physical:{heightMm:800,widthMm:480,depthMm:30,netWeightKg:3},
      clearanceEffect:{
        protectedFaceEffectiveClearanceFromHeaterBodyMm:80,
        clearanceFromProtectionOuterSurfaceToCombustibleMm:50,
        protectionProjectionReferenceMm:30,
        frontClearanceMm:300,
        note:'Harvia Figure 8 gives B/C=50 and F=30; Harvia technical data expresses the resulting heater-body clearance as 80 mm.'
      },
      verification:{status:'verified-clearance-effect',installedTransformComplete:false},
      source:{productPage:'https://www.harvia.com/en/products/WL400/protective-sheath-m'}
    },
    'harvia-wl450':{
      render:{
        role:'stove-full-protective-sheath',
        form:'three-sided-folded-steel-shell',
        finish:'black-painted-steel',
        overallEnvelopeAuthority:'physical',
        installedTransformAuthority:'heater-system-engine',
        installationVisualRequired:true
      },
      id:'harvia-wl450',
      identity:{manufacturer:'Harvia',model:'WL450',type:'stove-attached-full-sheath'},
      compatibleModelIds:['harvia-m3'],
      permittedPositions:['full'],
      physical:{heightMm:800,widthMm:455,depthMm:490,netWeightKg:7},
      clearanceEffect:{
        protectedFaceEffectiveClearanceFromHeaterBodyMm:80,
        clearanceFromProtectionOuterSurfaceToCombustibleMm:50,
        protectionProjectionReferenceMm:30,
        frontClearanceMm:300
      },
      verification:{status:'verified-clearance-effect',installedTransformComplete:false},
      source:{productPage:'https://www.harvia.com/en/products/WL450/protective-sheath-m-full'}
    },
    'harvia-wl425':{
      render:{
        role:'stove-side-protective-sheath',
        form:'thin-folded-steel-panel',
        finish:'black-painted-steel',
        overallEnvelopeAuthority:'physical',
        installedTransformAuthority:'heater-system-engine',
        installationVisualRequired:true
      },
      id:'harvia-wl425',
      identity:{manufacturer:'Harvia',model:'WL425',type:'stove-attached-side-sheath'},
      compatibleModelIds:['harvia-linear-16'],
      permittedPositions:['left','right'],
      physical:{heightMm:815,widthMm:516,depthMm:32,netWeightKg:3.2},
      clearanceEffect:{
        protectedFaceEffectiveClearanceFromHeaterBodyMm:62,
        clearanceFromProtectionOuterSurfaceToCombustibleMm:30,
        protectionProjectionReferenceMm:32,
        frontClearanceMm:400,
        note:'Harvia Figure 8 gives B/C=30 and F=32; Harvia technical data expresses the resulting heater-body clearance as 62 mm.'
      },
      verification:{status:'verified-clearance-effect',installedTransformComplete:false},
      source:{productPage:'https://www.harvia.com/en/products/WL425/protective-sheath-linear-16-side'}
    },
    'harvia-wl475':{
      render:{
        role:'stove-full-protective-sheath',
        form:'three-sided-folded-steel-shell',
        finish:'black-painted-steel',
        overallEnvelopeAuthority:'physical',
        installedTransformAuthority:'heater-system-engine',
        installationVisualRequired:true
      },
      id:'harvia-wl475',
      identity:{manufacturer:'Harvia',model:'WL475',type:'stove-attached-full-sheath'},
      compatibleModelIds:['harvia-linear-16'],
      permittedPositions:['full'],
      physical:{heightMm:815,widthMm:486,depthMm:516,netWeightKg:7.5},
      clearanceEffect:{
        protectedFaceEffectiveClearanceFromHeaterBodyMm:62,
        clearanceFromProtectionOuterSurfaceToCombustibleMm:30,
        protectionProjectionReferenceMm:32,
        frontClearanceMm:400
      },
      verification:{status:'verified-clearance-effect',installedTransformComplete:false},
      source:{productPage:'https://www.harvia.com/en/products/WL475/protective-sheath-h16-full'}
    },
    'harvia-wl200':{
      render:{
        role:'legend-protective-panel',
        form:'curved-black-steel-panel',
        finish:'black-painted-steel',
        overallEnvelopeAuthority:'physical',
        installedTransformAuthority:'heater-system-engine',
        installationVisualRequired:true
      },
      id:'harvia-wl200',
      identity:{manufacturer:'Harvia',model:'WL200',type:'legend-circumferential-protective-panel'},
      compatibleModelIds:['harvia-legend-150','harvia-legend-240','harvia-legend-300'],
      configuration:{
        minPanels:1,
        maxPanels:3,
        semanticProtectedFaces:['left','rear','right'],
        exactPanelTransformsStatus:'reserved-for-render-geometry-stage'
      },
      physical:{heightMm:1000,widthMm:520,depthMm:125,netWeightKg:6.8},
      installation:{
        nominalPanelToStoveAdjustmentGapMm:10,
        clearanceFromProtectionOuterSurfaceToCombustibleMm:30
      },
      clearanceEffect:{
        protectedFaceEffectiveClearanceFromHeaterBodyMm:65,
        frontClearanceUnchanged:true,
        note:'Current Harvia technical data gives B/C=65 mm with WL200. The WL200 installation drawing separately shows 30 mm from the protective sheath to a combustible wall.'
      },
      verification:{status:'verified-clearance-effect',installedTransformComplete:false},
      source:{
        productPage:'https://www.harvia.com/en/products/WL200/protective-sheath-legend-black',
        installationGuide:'Harvia WL200 installation guide'
      }
    }
  },

  protectionConfigurations:{
  'harvia-linear-22-unshielded':{id:'harvia-linear-22-unshielded',modelId:'harvia-linear-22',status:'verified-base',installedProtection:[],effectiveClearancesFromHeaterBody:{combustible:{frontMm:500,rearMm:380,leftMm:400,rightMm:400,aboveMm:1265}}},
  'harvia-linear-22-wl525-left':{id:'harvia-linear-22-wl525-left',modelId:'harvia-linear-22',status:'verified-protected',installedProtection:[{systemId:'harvia-wl525',position:'left'}],effectiveClearancesFromHeaterBody:{combustible:{frontMm:500,rearMm:380,leftMm:110,rightMm:400,aboveMm:1265}}},
  'harvia-linear-22-wl525-right':{id:'harvia-linear-22-wl525-right',modelId:'harvia-linear-22',status:'verified-protected',installedProtection:[{systemId:'harvia-wl525',position:'right'}],effectiveClearancesFromHeaterBody:{combustible:{frontMm:500,rearMm:380,leftMm:400,rightMm:110,aboveMm:1265}}},
  'harvia-linear-22-wl575-full':{id:'harvia-linear-22-wl575-full',modelId:'harvia-linear-22',status:'verified-protected',installedProtection:[{systemId:'harvia-wl575',position:'full'}],effectiveClearancesFromHeaterBody:{combustible:{frontMm:500,rearMm:110,leftMm:110,rightMm:110,aboveMm:1265}}},

    'harvia-m3-unshielded':{
      id:'harvia-m3-unshielded',modelId:'harvia-m3',status:'verified-base',installedProtection:[],
      effectiveClearancesFromHeaterBody:{combustible:{frontMm:300,rearMm:300,leftMm:250,rightMm:250,aboveMm:1200},source:'model-base'}
    },
    'harvia-m3-wl400-left':{
      id:'harvia-m3-wl400-left',modelId:'harvia-m3',status:'verified-clearance',
      installedProtection:[{systemId:'harvia-wl400',position:'left'}],
      effectiveClearancesFromHeaterBody:{combustible:{frontMm:300,rearMm:300,leftMm:80,rightMm:250,aboveMm:1200}},
      protectionOuterSurfaceClearances:{leftMm:50},
      source:'Harvia WL400/WL450 Figure 8 + technical data'
    },
    'harvia-m3-wl400-right':{
      id:'harvia-m3-wl400-right',modelId:'harvia-m3',status:'verified-clearance',
      installedProtection:[{systemId:'harvia-wl400',position:'right'}],
      effectiveClearancesFromHeaterBody:{combustible:{frontMm:300,rearMm:300,leftMm:250,rightMm:80,aboveMm:1200}},
      protectionOuterSurfaceClearances:{rightMm:50},
      source:'Harvia WL400/WL450 Figure 8 + technical data'
    },
    'harvia-m3-wl450-full':{
      id:'harvia-m3-wl450-full',modelId:'harvia-m3',status:'verified-clearance',
      installedProtection:[{systemId:'harvia-wl450',position:'full'}],
      effectiveClearancesFromHeaterBody:{combustible:{frontMm:300,rearMm:80,leftMm:80,rightMm:80,aboveMm:1200}},
      protectionOuterSurfaceClearances:{rearMm:50,leftMm:50,rightMm:50},
      source:'Harvia WL400/WL450 Figure 8 + technical data'
    },

    'harvia-linear-16-unshielded':{
      id:'harvia-linear-16-unshielded',modelId:'harvia-linear-16',status:'verified-base',installedProtection:[],
      effectiveClearancesFromHeaterBody:{combustible:{frontMm:400,rearMm:350,leftMm:300,rightMm:300,aboveMm:1300},source:'model-base'}
    },
    'harvia-linear-16-wl425-left':{
      id:'harvia-linear-16-wl425-left',modelId:'harvia-linear-16',status:'verified-clearance',
      installedProtection:[{systemId:'harvia-wl425',position:'left'}],
      effectiveClearancesFromHeaterBody:{combustible:{frontMm:400,rearMm:350,leftMm:62,rightMm:300,aboveMm:1300}},
      protectionOuterSurfaceClearances:{leftMm:30},
      source:'Harvia WL425/WL475 Figure 8 + technical data'
    },
    'harvia-linear-16-wl425-right':{
      id:'harvia-linear-16-wl425-right',modelId:'harvia-linear-16',status:'verified-clearance',
      installedProtection:[{systemId:'harvia-wl425',position:'right'}],
      effectiveClearancesFromHeaterBody:{combustible:{frontMm:400,rearMm:350,leftMm:300,rightMm:62,aboveMm:1300}},
      protectionOuterSurfaceClearances:{rightMm:30},
      source:'Harvia WL425/WL475 Figure 8 + technical data'
    },
    'harvia-linear-16-wl475-full':{
      id:'harvia-linear-16-wl475-full',modelId:'harvia-linear-16',status:'verified-clearance',
      installedProtection:[{systemId:'harvia-wl475',position:'full'}],
      effectiveClearancesFromHeaterBody:{combustible:{frontMm:400,rearMm:62,leftMm:62,rightMm:62,aboveMm:1300}},
      protectionOuterSurfaceClearances:{rearMm:30,leftMm:30,rightMm:30},
      source:'Harvia WL425/WL475 Figure 8 + technical data'
    }
  },

  floorSystems:{
    'harvia-wl100':{
      id:'harvia-wl100',
      identity:{manufacturer:'Harvia',model:'WL100',type:'protective-bedding'},
      render:{
        role:'floor-protection',
        form:'low-rectangular-protective-base',
        finish:'black-painted-aluminium-zinc-coated-steel',
        heightAdjustmentFeet:4,
        overallEnvelopeAuthority:'physical',
        installationVisualRequired:true
      },
      physical:{widthMm:450,depthMm:665,heightMm:60,netWeightKg:10.7},
      compatibleModelIds:['harvia-m3','harvia-linear-16','harvia-legend-150','harvia-legend-240','harvia-legend-300'],
      permittedSubstrates:['wood','waterproofed-tile'],
      verification:{status:'verified-for-m3',blockingItems:[]},
      source:{
        productPage:'https://www.harvia.com/en/products/WL100/protective-bedding-legend-470x665-black',
        manufacturerInstructionsMirror:'https://www.saunasenzwembaden.nl/wp-content/uploads/manual-linear.pdf'
      }
    }
  },

  installationComponents:{
    'harvia-wz115100':{
      id:'harvia-wz115100',
      identity:{manufacturer:'Harvia',model:'WZ115100',type:'single-wall-smoke-pipe'},
      assemblyRole:'single-wall-connector',
      compatibility:{nominalFlueDiameterMm:115,allHarviaWoodHeatersExcept:['harvia-50']},
      physical:{lengthMm:1000,outsideDiameterMm:115,netWeightKg:2},
      safety:{
        combustibleRadialClearanceMm:500,
        combustibleCeilingClearanceMm:1000,
        sourceAuthority:'Harvia product data'
      },
      render:{
        primitive:'cylinder',
        finish:'stainless-steel',
        geometryAuthority:'physical',
        cuttableLength:false
      },
      source:{productPage:'https://www.harvia.com/en/products/WZ115100/smoke-pipe-10115-steel'}
    },

    'harvia-wz90st':{
      id:'harvia-wz90st',
      identity:{manufacturer:'Harvia',model:'WZ90ST',type:'single-wall-90-degree-elbow'},
      assemblyRole:'single-wall-direction-change',
      compatibility:{nominalFlueDiameterMm:115,allHarviaWoodHeatersExcept:['harvia-50']},
      physical:{outsideDiameterMm:115,angleDeg:90,netWeightKg:0.8},
      safety:{
        combustibleRadialClearanceMm:500,
        combustibleCeilingClearanceMm:1000,
        sourceAuthority:'Harvia product data'
      },
      render:{
        primitive:'elbow',
        finish:'stainless-steel',
        diameterAuthority:'physical',
        centrelineRadiusMm:null,
        exactCentrelineGeometryStatus:'manufacturer-dimension-required'
      },
      source:{productPage:'https://www.harvia.com/en/products/WZ90ST/angle-pipe-90115-rst'}
    },

    'harvia-wz020130':{
      id:'harvia-wz020130',
      identity:{manufacturer:'Harvia',model:'WZ020130',type:'single-wall-radiation-cover'},
      assemblyRole:'single-wall-radiation-protection',
      compatibility:{nominalFlueDiameterMm:115},
      physical:{heightMm:235,widthMm:130,depthMm:130,netWeightKg:1},
      safetyEffect:{
        unprotectedPipeClearanceMm:500,
        protectedPipeClearanceMm:250,
        appliesTo:'covered-single-wall-smoke-pipe',
        sourceAuthority:'Harvia wood-heater installation instructions'
      },
      render:{
        primitive:'cylindrical-guard',
        finish:'stainless-steel',
        overallEnvelopeAuthority:'physical',
        installationVisualRequired:true
      },
      source:{
        productPage:'https://www.harvia.com/fi/tuotteet/WZ020130/putken-suoja-rst',
        manualEvidence:'Harvia wood-heater manuals: 500 mm unprotected / 250 mm with WZ020130'
      }
    },

    'jeremias-ferro1961-dn115-candidate':{
      id:'jeremias-ferro1961-dn115-candidate',
      identity:{
        manufacturer:'Jeremias',
        family:'FERRO-LUX',
        model:'FERRO1961',
        type:'single-wall-radiation-shield-candidate'
      },
      assemblyRole:'single-wall-radiation-protection-candidate',
      compatibility:{
        nominalPipeDiameterMm:115,
        documentedPipeSystem:'Jeremias FERRO DN115',
        compatibleWithHarviaWZ115100:'not-confirmed',
        automaticSelectionAllowed:false,
        releaseRule:'May only be selected for a Harvia WZ115100 installation after documentation or manufacturer confirmation establishes compatibility with the actual pipe and installation.'
      },
      physical:{
        nominalLengthMm:1000,
        shieldCoverageDeg:180,
        exactInstalledRadialOffsetMm:null,
        installedGeometryStatus:'mounting-gap-dimension-not-authoritative'
      },
      safetyEffect:{
        documentedOnJeremiasFerroDN115:{
          unprotectedClearanceMm:500,
          reductionFactor:0.5,
          resultingClearanceMm:250,
          sourceAuthority:'Jeremias Finland FERRO installation instructions'
        },
        transferToHarviaWZ115100:'not-authorised-without-compatibility-confirmation'
      },
      verification:{
        status:'candidate-system-specific',
        autoSelectable:false,
        currentHarviaCompatibilityVerified:false,
        note:'Jeremias documents DN115 FERRO pipe and states its smoke-pipe guard halves the clearance. This record does not transfer that system-specific result to Harvia WZ115100 without confirmation.'
      },
      source:{
        manufacturerInstructions:'https://jeremias.fi/fileadmin/user_upload/fi_data/download/Installation/Jeremias_FI_FERRO-LUX_Kaeyttoeohjeet.pdf',
        currentRetailReference:'https://www.taloon.com/savuputken-suoja-jeremias-1000-mm-o115'
      }
    },

    'harvia-wz020115':{
      id:'harvia-wz020115',
      identity:{manufacturer:'Harvia',model:'WZ020115',type:'smoke-pipe-lead-through-flange'},
      assemblyRole:'non-insulated-smoke-pipe-wall-finish-collar',
      compatibility:{nominalFlueDiameterMm:115},
      physical:{netWeightKg:0.2},
      installation:{
        construction:'two-piece-stainless-steel',
        purpose:'covers flue-opening edges and sealing gap',
        combustibleWallPenetrationApproved:false,
        note:'Do not treat this decorative collar as a timber-wall fire-stop or insulated chimney penetration.'
      },
      render:{
        primitive:'two-piece-flange',
        finish:'stainless-steel',
        exactOutlineStatus:'manufacturer-dimension-required'
      },
      source:{productPage:'https://www.harvia.com/en-US/products/WZ020115/wz020115'}
    },

    'harvia-whp1500-module':{
      id:'harvia-whp1500-module',
      identity:{manufacturer:'Harvia',model:'WHP1500 insulated module',type:'insulated-chimney-module'},
      assemblyRole:'insulated-twin-wall-chimney',
      physical:{lengthMm:1500,outerDiameterMm:220},
      render:{
        primitive:'insulated-cylinder',
        finish:'stainless-steel',
        geometryAuthority:'physical'
      },
      source:{productPage:'https://www.harvia.com/en/products/WHP1500/steel-chimney-1500-steel'}
    },

    'harvia-whp500':{
      id:'harvia-whp500',
      identity:{manufacturer:'Harvia',model:'WHP500',type:'insulated-chimney-extension'},
      assemblyRole:'insulated-twin-wall-extension',
      physical:{lengthMm:500,outerDiameterMm:220,netWeightKg:3.5},
      supportLimits:{indoorUnsupportedHeightMm:3000,outdoorUnsupportedHeightMm:2000},
      render:{primitive:'insulated-cylinder',finish:'stainless-steel',geometryAuthority:'physical'},
      source:{productPage:'https://www.harvia.com/en/products/WHP500/steel-chimney-extension-500-mm'}
    },

    'harvia-whp1000':{
      id:'harvia-whp1000',
      identity:{manufacturer:'Harvia',model:'WHP1000',type:'insulated-chimney-extension'},
      assemblyRole:'insulated-twin-wall-extension',
      physical:{lengthMm:1000,outerDiameterMm:220,netWeightKg:6.7},
      supportLimits:{indoorUnsupportedHeightMm:3000,outdoorUnsupportedHeightMm:2000},
      render:{primitive:'insulated-cylinder',finish:'stainless-steel',geometryAuthority:'physical'},
      source:{productPage:'https://www.harvia.com/en/products/WHP1000/steel-chimney-extension-1000-mm'}
    },

    'harvia-whp-rain-cap':{
      id:'harvia-whp-rain-cap',
      identity:{manufacturer:'Harvia',model:'WX139',type:'chimney-rain-cap'},
      assemblyRole:'terminal',
      suppliedWithSystemId:'harvia-whp1500',
      physical:{geometryStatus:'kit-component-detail-to-be-dimensioned'},
      render:{primitive:'rain-cap',finish:'stainless-steel',installationVisualRequired:true},
      verification:{status:'verified-component-identity; exact geometry deferred'}
    },

    'harvia-whp-rain-flange':{
      id:'harvia-whp-rain-flange',
      identity:{manufacturer:'Harvia',model:'WHM22',installationSetModel:'WHM23',type:'rubber-roof-rain-flange'},
      assemblyRole:'roof-weathering',
      suppliedWithSystemId:'harvia-whp1500',
      physical:{geometryStatus:'kit-component-detail-to-be-dimensioned'},
      installation:{profiledRoofRequiresUniformStiffenedMetalSupportSheet:true},
      render:{primitive:'roof-flashing-boot',finish:'rubber',installationVisualRequired:true},
      verification:{status:'verified-component-identity-and-profiled-roof-installation-rule; exact geometry deferred'}
    },

    'harvia-whp-ceiling-flange':{
      id:'harvia-whp-ceiling-flange',
      identity:{manufacturer:'Harvia',model:'ZSHP-711',type:'ceiling-lead-through-flange'},
      assemblyRole:'internal-penetration-finish',
      suppliedWithSystemId:'harvia-whp1500',
      physical:{geometryStatus:'kit-component-detail-to-be-dimensioned'},
      render:{primitive:'ceiling-flange',finish:'stainless-steel',installationVisualRequired:true},
      verification:{status:'verified-component-identity; exact geometry deferred'}
    },

    'harvia-whp-leadthrough-insulation':{
      id:'harvia-whp-leadthrough-insulation',
      identity:{manufacturer:'Harvia',model:'ZSH-200',type:'lead-through-insulation'},
      assemblyRole:'combustible-penetration-fire-protection',
      suppliedWithSystemId:'harvia-whp1500',
      physical:{heightMm:200,geometryStatus:'verified-height; radial geometry follows resolved WHP1500 clearance zone until exact component drawing is catalogued'},
      render:{primitive:'annular-insulation',finish:'insulation',installationVisualRequired:true},
      verification:{status:'verified-component-identity-and-200mm-height; exact radial component geometry deferred'}
    },

    'harvia-whp-leadthrough-protector':{
      id:'harvia-whp-leadthrough-protector',
      identity:{manufacturer:'Harvia',model:'ZSHP-712',type:'lead-through-protector'},
      assemblyRole:'combustible-penetration-fire-protection',
      suppliedWithSystemId:'harvia-whp1500',
      physical:{heightMm:500,geometryStatus:'verified-height-only; exact radial component geometry deferred'},
      render:{primitive:'penetration-protector',finish:'metal',installationVisualRequired:true},
      verification:{status:'verified-component-identity-and-500mm-height; exact radial component geometry deferred'}
    }
  },

  flueSystems:{
    'harvia-whp1500':{
      id:'harvia-whp1500',
      identity:{manufacturer:'Harvia',model:'WHP1500',type:'steel-chimney-kit'},
      applicability:{
        standaloneOutdoorSaunaOnly:true,
        note:'Harvia Support currently limits WHP1500 suitability to standalone outdoor sauna buildings.'
      },
      kit:{
        insulatedModuleLengthMm:1500,
        smokePipeNominalDiameterMm:115,
        insulatedOuterDiameterMm:220,
        includesNonInsulatedSmokePipeLengthMm:1000,
        includesRainCap:true,
        includesRainFlange:true,
        includesCeilingLeadThroughFlange:true,
        includesLeadThroughInsulationAndProtector:true
      },
      componentGraph:{
        required:[
          {componentId:'harvia-wz115100',quantity:1,role:'initial-single-wall-connector'},
          {componentId:'harvia-whp1500-module',quantity:1,role:'base-insulated-chimney'},
          {componentId:'harvia-whp-rain-cap',quantity:1,role:'terminal'},
          {componentId:'harvia-whp-rain-flange',quantity:1,role:'roof-weathering'},
          {componentId:'harvia-whp-ceiling-flange',quantity:1,role:'internal-penetration-finish'},
          {componentId:'harvia-whp-leadthrough-insulation',quantity:1,role:'penetration-fire-protection'},
          {componentId:'harvia-whp-leadthrough-protector',quantity:1,role:'penetration-fire-protection'}
        ],
        optional:[
          {componentId:'harvia-whp500',role:'height-extension'},
          {componentId:'harvia-whp1000',role:'height-extension'},
          {componentId:'harvia-wz020130',role:'single-wall-clearance-reduction'},
          {componentId:'harvia-wz90st',role:'rear-wall-route-direction-change'}
        ]
      },
      installationConstraints:{
        orientation:'vertical-only',
        maximumTotalHeightMm:5000,
        maximumSelfSupportingHeightMm:2000,
        insulatedOuterCasingClearanceToCombustibleMm:100,
        nonInsulatedSmokePipeClearanceToCombustibleMm:500,
        minimumVisibleInsulatedSectionBelowLeadThroughMm:430,
        terminalHeightRule:{
          id:'harvia-terminal-800-plus-100-per-m-v1',
          baseRiseAboveRoofAtFlueCentrelineMm:800,
          additionalRisePerMetreFromReferenceMm:100,
          measuredFrom:'roof surface at the flue centreline',
          distanceMeasuredFrom:'ridge, in plan',
          reference:{pitchedGable:'ridge',monopitch:'high-roof-edge'},
          source:{
            authority:'Harvia installation manual, as supplied by the ThermoAspen owner on 2026-10-21',
            document:null,
            page:null
          },
          verificationStatus:'owner-confirmed-citation-pending',
          note:'Harvia states the distance is measured from the ridge. A monopitch roof has no ridge, so ThermoAspen uses the high roof edge as the equivalent reference; that equivalence is not manufacturer text.'
        },
        leadThroughInsulationId:'ZSH-200',
        leadThroughProtectorId:'ZSHP-712',
        minimumAlternativeLeadThroughInsulationServiceTempC:750
      },
      transitionRules:{
        whenStoveProtectionInstalled:'insulated-chimney-must-start-at-or-below-top-of-protective-sheath',
        unshielded:'satisfy-chimney-lead-through-and-visible-insulated-section-rules',
        resolution:'use-the-more-restrictive-lower-transition-point',
        note:'The earlier ThermoAspen idea of a fixed 50 mm pre-penetration transition is not authoritative for WHP1500.'
      },
      extensions:[
        {id:'WHP500',lengthMm:500,insulatedLengthMm:470},
        {id:'WHP1000',lengthMm:1000,insulatedLengthMm:970}
      ],
      verification:{
        status:'verified-core-installation-constraints',
        blockingItems:[
          'Exact detailed lead-through component geometry remains to be modelled for drawings.',
          'Bend/elbow routing belongs to single-wall connector components, because WHP1500 itself is vertical-only.'
        ]
      },
      source:{
        productPage:'https://www.harvia.com/en/products/WHP1500/steel-chimney-1500-steel',
        supportArticle:'https://support.harvia.com/hc/en-gb/articles/25312826130716-Steel-Chimney-Harvia-WHP1500',
        installationManualMirror:'https://manuals.plus/m/05309b662bbbd251c0d0a075ce817333d28609e281ca89ea4dbb3d9dd3babe93'
      }
    }
  }
};

function outletComplete(o){
  if(!o||o.enabled!==true)return true;
  var c=o.centreMm||{},a=o.axis||{};
  return isNum(c.x)&&isNum(c.y)&&isNum(c.z)&&isNum(a.x)&&isNum(a.y)&&isNum(a.z);
}
function automaticEligible(m){
  if(!m||!m.selection||m.selection.enabled===false)return false;
  if(m.identity&&m.identity.fuel==='electric')return false; // separate preliminary recommendation; mounting remains conditional
  if(!m.verification||m.verification.criticalDataComplete!==true)return false;
  var os=m.flue&&m.flue.outlets||{},keys=Object.keys(os).filter(function(k){return os[k]&&os[k].enabled===true});
  return keys.length>0&&keys.every(function(k){return outletComplete(os[k])});
}
function validate(){
  var errors=[],warnings=[],ids=Object.keys(DATA.models);
  ids.forEach(function(id){
    var m=DATA.models[id],p='models.'+id;
    if(!m||m.id!==id)issue(errors,'MODEL_KEY_ID_MISMATCH',p,'Object key and model id must match.');
    if(!m.identity||['wood','electric'].indexOf(m.identity.fuel)<0)issue(errors,'MODEL_FUEL_INVALID',p+'.identity.fuel','Model fuel must be wood or electric.');
    if(!m.sizing||!pos(m.sizing.saunaVolumeMinM3)||!pos(m.sizing.saunaVolumeMaxM3)||m.sizing.saunaVolumeMinM3>m.sizing.saunaVolumeMaxM3)issue(errors,'MODEL_VOLUME_INVALID',p+'.sizing','Invalid manufacturer sauna-volume range.');
    ['widthMm','depthMm','heightMm'].forEach(function(k){if(!m.physical||!pos(m.physical[k]))issue(errors,'MODEL_DIMENSION_INVALID',p+'.physical.'+k,'Dimension must be positive.');});
    var c=m.clearances&&m.clearances.base&&m.clearances.base.combustible||{};
    ['frontMm','rearMm','leftMm','rightMm','aboveMm'].forEach(function(k){if(m.identity&&m.identity.fuel==='electric'&&k==='rearMm'&&c[k]==null)issue(warnings,'ELECTRIC_REAR_MOUNT_CLEARANCE_UNVERIFIED',p+'.clearances.base.combustible.'+k,'Rear bracket/wall mount is not verified; layout remains conditional.');else if(!isNum(c[k])||c[k]<0)issue(errors,'MODEL_CLEARANCE_INVALID',p+'.clearances.base.combustible.'+k,'Base combustible clearance is required.');});
    var os=m.flue&&m.flue.outlets||{};
    Object.keys(os).forEach(function(k){if(os[k].enabled===true&&!outletComplete(os[k]))issue(warnings,'MODEL_FLUE_OUTLET_INCOMPLETE',p+'.flue.outlets.'+k,'Exact manufacturer outlet coordinates are not yet verified.');});
    if(!automaticEligible(m))issue(warnings,'MODEL_NOT_AUTO_SELECTABLE',p+'.verification','Model is blocked from automatic selection until critical data is complete.');
  });
  Object.keys(DATA.protectionConfigurations).forEach(function(id){
    var q=DATA.protectionConfigurations[id],p='protectionConfigurations.'+id,c=(q.effectiveClearancesFromHeaterBody&&q.effectiveClearancesFromHeaterBody.combustible)||(q.effectiveClearances&&q.effectiveClearances.combustible)||{};
    ['frontMm','rearMm','leftMm','rightMm','aboveMm'].forEach(function(k){if(c[k]==null)issue(warnings,'PROTECTION_CLEARANCE_UNVERIFIED',p+'.effectiveClearances.combustible.'+k,'Manufacturer-approved resulting clearance is not yet entered.');});
  });
  return {schemaVersion:SCHEMA_VERSION,catalogueVersion:VERSION,valid:errors.length===0,modelCount:ids.length,automaticEligibleModelCount:ids.filter(function(id){return automaticEligible(DATA.models[id])}).length,errors:errors,warnings:warnings};
}
var API={
  version:VERSION,schemaVersion:SCHEMA_VERSION,units:UNITS,
  getData:function(){return clone(DATA)},
  getVisualProfile:function(id){return DATA.visualProfiles[id]?clone(DATA.visualProfiles[id]):null},
  getModelVisualProfile:function(modelId){
    var m=DATA.models[normaliseModelId(modelId)];
    return m&&m.visualProfileId&&DATA.visualProfiles[m.visualProfileId]?clone(DATA.visualProfiles[m.visualProfileId]):null
  },
  getModel:function(id){id=normaliseModelId(id);return DATA.models[id]?clone(DATA.models[id]):null},
  normaliseModelId:function(id){return normaliseModelId(id)},
  getLegacyModelIds:function(){return clone(LEGACY_MODEL_IDS)},
  listModels:function(){return Object.keys(DATA.models).map(function(id){return clone(DATA.models[id])})},
  listElectricModels:function(){return Object.keys(DATA.models).filter(function(id){return DATA.models[id].identity.fuel==='electric'}).map(function(id){return clone(DATA.models[id])})},
  listAutomaticModels:function(){return Object.keys(DATA.models).filter(function(id){return automaticEligible(DATA.models[id])}).map(function(id){return clone(DATA.models[id])})},
  getInstallationComponent:function(id){return DATA.installationComponents[id]?clone(DATA.installationComponents[id]):null},
  listInstallationComponents:function(){return Object.keys(DATA.installationComponents).map(function(id){return clone(DATA.installationComponents[id])})},
  getProtectionSystem:function(id){return DATA.protectionSystems[id]?clone(DATA.protectionSystems[id]):null},
  getProtectionConfiguration:function(id){return DATA.protectionConfigurations[id]?clone(DATA.protectionConfigurations[id]):null},
  listProtectionConfigurationsForModel:function(modelId){modelId=normaliseModelId(modelId);return Object.keys(DATA.protectionConfigurations).filter(function(id){return DATA.protectionConfigurations[id].modelId===modelId}).map(function(id){return clone(DATA.protectionConfigurations[id])})},
  getFloorSystem:function(id){return DATA.floorSystems[id]?clone(DATA.floorSystems[id]):null},
  getFlueSystem:function(id){return DATA.flueSystems[id]?clone(DATA.flueSystems[id]):null},
  validate:validate
};
W.ThermoAspenHeaterCatalogue=API;
try{W.dispatchEvent(new CustomEvent('ThermoAspenHeaterCatalogueReady',{detail:{version:VERSION,schemaVersion:SCHEMA_VERSION,validation:validate()}}))}catch(e){}
})(window);
